module.exports = __webpack_public_path__ + "img/denis_header_mobile.2502d6ce.jpg";